import styled from "styled-components";
import { useContext, useState } from "react";
import { AuthContext } from "../Auth/AuthProvider";
import { useNavigate } from "react-router-dom";
import SmallLoading from "../Componentes/Utils/SmallLoading";

const ContainerBody = styled.div`
    width: 100%;
    height: 100dvh;
    background-color: #242d34;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const ContainerModal = styled.div`
  width: 550px;
  max-width: 95%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  margin: auto;
  box-sizing: border-box;
  h2{
    margin: 0 auto;
    font-size: 24px;
    color: #333;
  }
  p{
    margin: 5px auto 25px auto;
    font-size: 16px;
    color: #555;
  }
`;

const ModulesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
const ModuleOption = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${(props) => (props.$active ? "#e8f0fe" : "#fff")};
  &:hover {
    background-color: #f0f4f8;  
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 15px;
`;

const Button = styled.button`
  width: 50%;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  background-color: ${({ tipo }) => tipo === 'login' ? '#007bff' : '#da0000'};
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const PoliticaPrivacidade = styled.p`
    font-size: 12px;
    color: #666;
    text-align: center;
    margin-top: 0;
    margin-bottom: 5px;
`


const ModuleSelector = () => {
  const { user, logout } = useContext(AuthContext);
  const [selectedModule, setSelectedModule] = useState("");
  const navigate = useNavigate();

  if (!user || !user.PERMISSIONS) {
    return <ContainerBody>
      <SmallLoading />
    </ContainerBody>;
  }

  let modulos = [];

  if (user.IS_ADMIN === true ) {
    modulos = user.PERMISSIONS.filter((p) => p.funcao === "access" && p.submodulo === null );
  } else {
    modulos = user.PERMISSIONS.filter(
      (p) => p.funcao === "access" && p.submodulo === null
    );
  }

  const handleJoin = () => {
    if (selectedModule) {
      navigate(`/modulo/${selectedModule}`);
    }
  };

  return (
    <ContainerBody>
      <ContainerModal>
        <h2>Bem-vindo!</h2>
        <p>Selecione um módulo para acessar:</p>
        {
          modulos.length === 0 && (
            <p style={{ color: "#f00" }}>Nenhum módulo disponível. Solicite liberação dos módulos ao seu gestor!</p>
          )
        }
        <ModulesContainer>
          {modulos.map((m) => (
            <ModuleOption
              key={m.modulo}
              $active={selectedModule === m.modulo}
              onClick={() => setSelectedModule(m.modulo)}
            >
              <input
                type="radio"
                name="module"
                value={m.modulo}
                checked={selectedModule === m.modulo}
                onChange={() => setSelectedModule(m.modulo)}
              />
              {m.modulo.toUpperCase()}
            </ModuleOption>
          ))}
        </ModulesContainer>
        <ButtonsContainer>
          <Button onClick={logout} >
            Sair
          </Button>
          <Button tipo="login" $primary disabled={!selectedModule} onClick={handleJoin}>
            Entrar
          </Button>
        </ButtonsContainer>
      </ContainerModal>
      <PoliticaPrivacidade>
        Acesse <a href="https://www.palmont.com.br/politica-de-privacidade" target="_blank" rel="noopener noreferrer">nossa política de privacidade</a> para mais informações.
      </PoliticaPrivacidade>
    </ContainerBody>
  );
};

export default ModuleSelector;